import {createContext, useContext} from 'react';

import type {FolderHashidSerializedType} from 'sweet-types';

interface FolderContextType {
  folder: FolderHashidSerializedType | undefined;
  refetch: () => void;
}
export const FolderContext = createContext<
  FolderContextType | Record<string, never>
>({});

export function useCurrentFolder() {
  return useContext(FolderContext);
}
